!function(e) {
     function t(t) {
       for (var r, a, l = t[0], u = t[1], s = t[2], c = 0, f = []; c < l.length; c++) a = l[c], Object.prototype.hasOwnProperty.call(o, a) && o[a] && f.push(o[a][0]), o[a] = 0;
       for (r in u) Object.prototype.hasOwnProperty.call(u, r) && (e[r] = u[r]);
       for (d && d(t); f.length;) f.shift()();
       return i.push.apply(i, s || []), n()
     }

     function n() {
       for (var e, t = 0; t < i.length; t++) {
         for (var n = i[t], r = !0, l = 1; l < n.length; l++) {
           var u = n[l];
           0 !== o[u] && (r = !1)
         }
         r && (i.splice(t--, 1), e = a(a.s = n[0]))
       }
       return e
     }
     var r = {},
       o = {
         4: 0
       },
       i = [];

     function a(t) {
       if (r[t]) return r[t].exports;
       var n = r[t] = {
         i: t,
         l: !1,
         exports: {}
       };
       return e[t].call(n.exports, n, n.exports, a), n.l = !0, n.exports
     }
     a.m = e, a.c = r, a.d = function(e, t, n) {
       a.o(e, t) || Object.defineProperty(e, t, {
         enumerable: !0,
         get: n
       })
     }, a.r = function(e) {
       "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
         value: "Module"
       }), Object.defineProperty(e, "__esModule", {
         value: !0
       })
     }, a.t = function(e, t) {
       if (1 & t && (e = a(e)), 8 & t) return e;
       if (4 & t && "object" == typeof e && e && e.__esModule) return e;
       var n = Object.create(null);
       if (a.r(n), Object.defineProperty(n, "default", {
           enumerable: !0,
           value: e
         }), 2 & t && "string" != typeof e)
         for (var r in e) a.d(n, r, function(t) {
           return e[t]
         }.bind(null, r));
       return n
     }, a.n = function(e) {
       var t = e && e.__esModule ? function() {
         return e.default
       } : function() {
         return e
       };
       return a.d(t, "a", t), t
     }, a.o = function(e, t) {
       return Object.prototype.hasOwnProperty.call(e, t)
     }, a.p = "";
     var l = window.shopifySlateJsonp = window.shopifySlateJsonp || [],
       u = l.push.bind(l);
     l.push = t, l = l.slice();
     for (var s = 0; s < l.length; s++) t(l[s]);
     var d = u;
     i.push([132, 2]), n()
   }({
     132: function(e, t, n) {
       "use strict";
       n(133), n(134)
     },
     133: function(e, t, n) {},
     134: function(e, t, n) {
       "use strict";
       var r = function(e) {
           return e && e.__esModule ? e : {
             default: e
           }
         }(n(107)),
         o = null,
         i = null,
         a = null;

       function l(e) {
         var t = window.innerWidth < 1125;
         e.querySelectorAll("canvas").forEach((function(e) {
           e.remove()
         })), null === o && null === i || (i.clear(a.world), o.clear(a)), o = r.default.Engine, i = r.default.World;
         var n = r.default.Render,
           l = r.default.Runner,
           u = r.default.Bodies,
           s = r.default.MouseConstraint,
           d = r.default.Mouse,
           c = e.clientWidth,
           f = 2 * e.clientHeight;
         (a = o.create()).world, a.enableSleeping = !0;
         var p = window.devicePixelRatio,
           y = n.create({
             element: e,
             engine: a,
             options: {
               wireframes: !1,
               showAngleIndicator: !1,
               background: "transparent",
               showSleeping: !1,
               width: c,
               height: f
             }
           });
         r.default.Render.setPixelRatio(y, p);
         var v = l.create();
         l.run(v, a);
         var h = {
             x: 1,
             y: 1
           },
           x = t ? {
             x: 124,
             y: 155
           } : {
             x: 300,
             y: 300
           };
         i.add(a.world, [u.rectangle(c / 2, f + 250, c, 500, {
             isStatic: !0
           }), u.rectangle(c / 2, -50, c, 100, {
             isStatic: !0
           }), u.rectangle(-50, f / 2, 100, f, {
             isStatic: !0
           }), u.rectangle(c + 50, f / 2, 100, f, {
             isStatic: !0
           })]),
           function() {
             var n = t ? "[data-mobile-shape]" : "[data-desktop-shape]";
             e.querySelectorAll(n).forEach((function(e) {
               var t = e.getAttribute("data-sprite");
               if (null !== t) {
                 var n = parseInt(e.getAttribute("data-width"), 10),
                   o = parseInt(e.getAttribute("data-height"), 10),
                   l = r.default.Bodies.rectangle(h.x * x.y, h.y * x.x, n, o, {
                     density: .8,
                     frictionAir: .01,
                     restitution: .5,
                     friction: .001,
                     render: {
                       fillStyle: "red",
                       strokeStyle: "transparent",
                       sprite: {
                         texture: t,
                         xScale: 1,
                         yScale: 1
                       }
                     }
                   }, 100);
                 i.add(a.world, l), r.default.Sleeping.update(l, 50), r.default.Body.rotate(l, Math.floor(360 * Math.random() + 1)), h.x++, h.x * x.x > c - x.x && (h.y++, h.x = 1)
               }
             }))
           }(),
           function() {
             var e = d.create(y.canvas),
               n = s.create(a, {
                 mouse: e,
                 constraint: {
                   stiffness: .2,
                   render: {
                     fillStyle: "transparent",
                     strokeStyle: "transparent",
                     visible: !1
                   }
                 }
               });
             if (i.add(a.world, n), !1 !== t) {
               e.element.removeEventListener("mousewheel", e.mousewheel), e.element.removeEventListener("DOMMouseScroll", e.mousewheel), y.mouse = e;
               var o = {
                   x: 0,
                   y: 0
                 },
                 l = 3.5,
                 u = 3.5,
                 c = {
                   x: e.position.x,
                   y: e.position.y
                 };
               r.default.Events.on(n, "mousemove", (function(e) {
                 var t = r.default.Composite.allBodies(a.world),
                   n = r.default.Query.point(t, e.mouse.position);
                 o.x = e.mouse.position.x - c.x, o.y = e.mouse.position.y - c.y, o.x > l ? o.x = l : o.x < -1 * l && (o.x = -1 * l), o.y > u ? o.y = u : o.y < -1 * u && (o.y = -1 * u), n.forEach((function(e) {
                   0 === o.x && 0 === o.y || (r.default.Sleeping.set(e, !1), r.default.Body.setVelocity(e, {
                     x: o.x,
                     y: o.y
                   }))
                 })), c.x = e.mouse.position.x, c.y = e.mouse.position.y
               }))
             }
           }();
         var m = t ? .05 : .1;
         a.world.gravity.y = m, o.run(a), n.run(y)
       }
       document.addEventListener("DOMContentLoaded", (function() {
         ! function() {
           var e = document.querySelector("[data-404-shape-holder]");
           e && (l(e), function(e) {
             var t = void 0,
               n = window.innerWidth;
             window.addEventListener("resize", (function() {
               clearTimeout(t), t = setTimeout((function() {
                 var t = window.innerWidth;
                 t < n + 20 && t > n - 20 || l(e)
               }), 250)
             }))
           }(e))
         }()
       }))
     }
   });